import React from "react";
import {PermissionGuard} from "../../components/PermissionGuard";
import {StoryboardFeature} from "../../features/storyBoard/components";

const ALLOWED_PERMISSION = 'storyBoard'

const StoryboardPage = ({
  userToken,
  userPermissions,
}) => (
  <PermissionGuard
    userToken={userToken}
    userPermissions={userPermissions}
    permissionKey={ALLOWED_PERMISSION}
  >
    <StoryboardFeature />
  </PermissionGuard>
)

export default StoryboardPage
